// renderContent — converte markdown básico → HTML para balões de chat
// Unificado de Chat.tsx e ChatHubPage.tsx

import { T } from '../styles/tokens';

let _codeBlockId = 0;

/** Reseta o contador de blocos de código (útil para testes) */
export function resetCodeBlockId() { _codeBlockId = 0; }

export function renderContent(text: string): string {
  return text
    // Strip OpenClaw system hints (não útil para usuário final)
    .replace(/To send an image back[\s\S]*?Keep caption in the text body\.\n?/g, '')
    .replace(/Conversation info \(untrusted metadata\):[\s\S]*?```\n?/g, '')
    // Strip notificações de exec do sistema
    .replace(/System: \[\d{4}-\d{2}-\d{2}[^\]]*\] Exec completed[^\n]*\n?/g, '')
    // Strip heartbeat prompts
    .replace(/Read HEARTBEAT\.md if it exists[\s\S]*?Current time:.*?\n?/g, '')
    // Strip "Pre-compaction memory flush" instructions
    .replace(/Pre-compaction memory flush\.[\s\S]*?reply with NO_REPLY\.\n?/g, '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/```(\w*)\n([\s\S]*?)```/g, (_match, lang: string, code: string) => {
      const id = `cb_${++_codeBlockId}`;
      const langLabel = lang || '';
      const highlighted = code
        .replace(/(&amp;&amp;|\|\||;;)/g, '<span style="color:#E06070;font-weight:600">$1</span>')
        .replace(/(\$\w+)/g, '<span style="color:#62D0FF">$1</span>');
      return `<div class="tg-code-block" style="position:relative;background:#1B1E2E;border-radius:8px;margin:8px 0;border-left:3px solid #3BA5A8;overflow:hidden">`
        + `<div style="display:flex;justify-content:space-between;align-items:center;padding:6px 10px 2px;opacity:0.5;font-size:11px">`
        + `<span style="font-family:'JetBrains Mono',monospace;color:${T.textSecondary}">${langLabel}</span>`
        + `<button onclick="(function(){var c=document.getElementById('${id}');if(c){navigator.clipboard.writeText(c.textContent||'');var b=event.currentTarget;b.textContent='';setTimeout(function(){b.textContent=''},1500)}})()" style="background:none;border:none;cursor:pointer;font-size:14px;padding:2px 4px;color:${T.textSecondary};line-height:1"></button>`
        + `</div>`
        + `<pre id="${id}" style="margin:0;padding:6px 12px 10px;overflow-x:auto;font-size:13px;line-height:1.5;font-family:'JetBrains Mono','Fira Code',monospace;color:${T.text}"><code>${highlighted}</code></pre>`
        + `</div>`;
    })
    .replace(/`([^`]+)`/g, '<code style="background:${T.bgSecondary};color:${T.purple};padding:2px 7px;border-radius:5px;font-size:12.5px;font-family:\'JetBrains Mono\',monospace">$1</code>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>')
    // File paths: match common patterns
    .replace(/(?:^|(?<=<br\/>))(\s*)((?:[\w.~\/-]+\/)?[\w.-]+\.(?:md|ts|tsx|js|jsx|json|yaml|yml|toml|html|css|sh|py|txt|log|env|cfg|conf|xml|sql))\s*(?=$|<br\/>)/gm, (_m, ws, filePath) => {
      const fileName = filePath.split('/').pop() || filePath;
      const ext = fileName.split('.').pop()?.toLowerCase() || '';
      const iconMap: Record<string, string> = {
        md: '📄', ts: '🟦', tsx: '🟦', js: '🟨', jsx: '🟨', json: '📋',
        html: '🌐', css: '🎨', sh: '⚙️', py: '🐍', yaml: '📝', yml: '📝',
        env: '🔒', sql: '🗃️', log: '📊', txt: '📃', xml: '📰', toml: '⚙️',
        conf: '⚙️', cfg: '⚙️',
      };
      const icon = iconMap[ext] || '📄';
      return `${ws}<div style="display:inline-flex;align-items:center;gap:8px;background:rgba(255,255,255,0.04);border-radius:8px;padding:8px 12px;margin:4px 0;cursor:pointer;max-width:100%" onclick="navigator.clipboard.writeText('${filePath.replace(/'/g, "\\'")}')">` +
        `<span style="font-size:20px;flex-shrink:0;opacity:0.7">${icon}</span>` +
        `<span style="font-family:'JetBrains Mono',monospace;font-size:12.5px;color:${T.text};white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${filePath}</span>` +
        `</div>`;
    })
    // Media attached — strip tag (cards renderizados como JSX)
    .replace(/\[media attached: [^\]]*\]/g, '')
    // URLs: links clicáveis
    .replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener" style="color:#62D0FF;text-decoration:none;word-break:break-all">$1</a>')
    .replace(/\n/g, '<br/>');
}
